import type { UseFormReturn } from 'react-hook-form';
import { Checkbox, Labeled, Select, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IUserContentReviewListFilterFormBodyValues } from './UserContentReviewListFilterFormBody';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IUserContentReviewListFilterFormMainSectionProps =
  IContainerProps & {
    form: UseFormReturn<IUserContentReviewListFilterFormBodyValues>;
    appId: string;
  };

export const UserContentReviewListFilterFormMainSection: React.FC<
  IUserContentReviewListFilterFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.toReview.label',
        )}
        labelPosition="right"
      >
        <FormField name="toReview" control={form.control} as={Checkbox} />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.reported.label',
        )}
        labelPosition="right"
      >
        <FormField name="reported" control={form.control} as={Checkbox} />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.moderated.label',
        )}
        labelPosition="right"
      >
        <FormField name="moderated" control={form.control} as={Checkbox} />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.ugcId.label',
        )}
      >
        <FormField
          name="ugcId"
          control={form.control}
          as={TextInputField}
          forwardError
          clearable
        />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.userId.label',
        )}
      >
        <FormField
          name="userId"
          control={form.control}
          as={TextInputField}
          forwardError
          clearable
        />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.parentId.label',
        )}
      >
        <FormField
          name="parentId"
          control={form.control}
          as={TextInputField}
          forwardError
          clearable
        />
      </Labeled>

      <Labeled
        label={t(
          'UserContentReviewListFilterFormMainSection.fields.type.label',
        )}
      >
        <FormField
          name="type"
          control={form.control}
          as={Select}
          forwardError
          items={[
            {
              value: 'article',
              label: t(
                'UserContentReviewListFilterFormMainSection.fields.type.options.article.label',
              ),
            },
            {
              value: 'comment',
              label: t(
                'UserContentReviewListFilterFormMainSection.fields.type.options.comment.label',
              ),
            },
            {
              value: '',
              label: t(
                'UserContentReviewListFilterFormMainSection.fields.type.options.all.label',
              ),
            },
          ]}
        />
      </Labeled>
    </FormSection>
  );
};
